export default "<div class=\" fixed-plugin\">\r\n</div>\r\n"